import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import type { Enums } from '@/lib/database.types'

interface RoleGuardProps {
  allowedRoles: Enums<'user_role'>[]
  children: React.ReactNode
}

export function RoleGuard({ allowedRoles, children }: RoleGuardProps) {
  const { profile, loading } = useAuth()

  if (loading) return null

  if (!profile || !allowedRoles.includes(profile.role)) {
    return (
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        height: '100vh', gap: 'var(--space-4)', fontFamily: 'var(--font-display)',
      }}>
        <h1 style={{ fontSize: 'var(--text-2xl)' }}>Access Denied</h1>
        <p style={{ color: 'var(--color-text-muted)' }}>You don't have permission to access this area.</p>
        <a href="/gaviota" style={{ color: 'var(--color-primary)' }}>Return to Dashboard</a>
      </div>
    )
  }

  return <>{children}</>
}
